import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    IconButton,
    Menu,
    MenuItem,
    Tooltip,
    Typography,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const TranslatorButton = () => {
    const { t, i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => setAnchorEl(null);

    const handleChangeLanguage = (language: string) => {
        i18n.changeLanguage(language);
        handleClose();
    };

    return (
        <>
            <Tooltip title={t('components.translatorButton.tooltip')}>
                <IconButton onClick={handleOpen} sx={{ color: 'white' }}>
                    <LanguageIcon />
                </IconButton>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem
                    selected={i18n.language?.startsWith('pt')}
                    onClick={() => handleChangeLanguage('pt')}
                >
                    <Typography ml={1}>Português</Typography>

                </MenuItem>
                <MenuItem
                    selected={i18n.language?.startsWith('en')}
                    onClick={() => handleChangeLanguage('en')}
                >
                    <Typography ml={1}>English</Typography>
                </MenuItem>
            </Menu>
        </>
    );
};

export default TranslatorButton;